const CREDIT_DIRECTION = -1;
const CREDIT_NOTE_TYPE_ID = 6;
const SALE_TYPE_ID = 8;

const buildTransactionTypeOptions = ({ invoice, payTypes = [] }) => {
  const availablePayTypes = payTypes.filter(
    payType =>
      (!invoice?.isExported || payType.numberId !== SALE_TYPE_ID) &&
      (invoice?.typeId !== 2 || payType.numberId !== CREDIT_NOTE_TYPE_ID),
  );

  const groupedPayTypes = availablePayTypes.reduce(
    (groups, payType) => {
      const groupName = payType.cd === CREDIT_DIRECTION ? "Credits" : "Debits";

      return {
        ...groups,
        [groupName]: [
          ...groups[groupName],
          { label: payType.name, value: payType.numberId },
        ],
      };
    },
    { Credits: [], Debits: [] },
  );

  return ["Debits", "Credits"]
    .map(label => ({ label, options: groupedPayTypes[label] }))
    .filter(group => group.options.length > 0);
};

export { buildTransactionTypeOptions };
